import React from "react";

import { __ } from "@wordpress/i18n";
import { Placeholder } from "@wordpress/components";
import { useDispatch } from "@wordpress/data";

import Templates from "./templates";

export default function CustomPlaceholder(props) {
	const { gutenberghubQcPlaceholder } = props.attributes;

	const { replaceBlock } = useDispatch("core/block-editor");

	const handleLayout = (layout) => {
		let createdBlock = wp.blocks.createBlocksFromInnerBlocksTemplate(
			layout.template,
		);

		replaceBlock(props.clientId, createdBlock[0]);
	};

	return (
		<Placeholder
			label={__("Pro Post Grid", "gutenberg-pro-ext")}
			instructions={__("Select a layout.", "gutenberg-pro-ext")}
			icon={
				<svg
					width="288"
					height="300"
					viewBox="0 0 288 300"
					style={{ fill: "none" }}
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M249.769 25H38.2308C27.6099 25 19 33.6099 19 44.2308V255.769C19 266.39 27.6099 275 38.2308 275H249.769C260.39 275 269 266.39 269 255.769V44.2308C269 33.6099 260.39 25 249.769 25Z"
						stroke="currentColor"
						strokeWidth="15"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						d="M95.9229 25V275M95.9229 150H269"
						stroke="currentColor"
						strokeWidth="15"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			}
		>
			<div className="ghub-query-placeholder-container">
				{Templates.map((template) => {
					return (
						<div className="ghub-query-image-placeholder-image">
							<img src={template.icon} onClick={() => handleLayout(template)} />
						</div>
					);
				})}
			</div>
		</Placeholder>
	);
}
